import React from 'react';
import './styles/Skills.scss';
import skillsData from '../config/skills';

const Skills = () => {
    return (
        <section id="skills" className="skills">
            <h2>Technical Skills</h2>
            <div className="skills-grid-container">
                {skillsData.map((skill, index) => (
                    <a
                        key={index}
                        href={skill.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="skill-item"
                    >
                        {skill.icon && <img src={skill.icon} alt={`${skill.name} icon`} />}
                        <span>{skill.name}</span>
                    </a>
                ))}
            </div>
        </section>
    );
};

export default Skills;